export const LOCAL_STORAGE_BASE_KEYS = {
  FILTER_BY_SERVICE_ADVISOR_ID: "shdbServiceWriterId",
  FILTER_BY_TECHNICIAN_ID: "shdbTechnicianId",
  DASHBOARD_LAYOUT_ID: "shdbLayoutId",
  DASHBOARD_CARD_ZOOM: "shdb.dashboardCardZoom",
  COMPACT_CONTAINER_HEADERS: "shdb.compactContainerHeaders",
  SHOP_ID: "shdb.shopId",
  BROWSER_ID: "shdb.browserId",
  ANALYTICS_TIMESTAMP: "shdb.analyticsTimestamp",
  CARD_METRICS_TIMESTAMPS_ENABLED: "shdb.cardMetricsTimestampsEnabled",
  CARD_METRICS_AGGREGATE_VIEW: "shdb.cardMetricsAggregateView",
  NOTIFICATION_SHEET_TAB: "shdb.notificationSheetTab",
  FILTER_BY_DUE_IN_START: "shdbDueInStart",
  FILTER_BY_DUE_IN_END: "shdbDueInEnd",
  FILTER_BY_DUE_OUT_START: "shdbDueOutStart",
  FILTER_BY_DUE_OUT_END: "shdbDueOutEnd",
  FILTER_BY_APPT_START_START: "shdbApptStartStart",
  FILTER_BY_APPT_START_END: "shdbApptStartEnd",
  FILTER_BY_APPT_END_START: "shdbApptEndStart",
  FILTER_BY_APPT_END_END: "shdbApptEndEnd",
  FILTER_BY_TAGS: "shdbTags",
  FILTER_BY_COLORS: "shdbColors",
  FILTER_BY_CONTAINER: "shdbContainer",
  CUSTOMER_UPDATE_TABLE_COLUMNS: "shdb.customerUpdateTableColumns",
  CUSTOMER_UPDATE_TABLE_STATE: "shdb.customerUpdateTableState",
  CARDS_TABLE_COLUMNS: "shdb.cardsTableColumns",
  CARDS_TABLE_STATE: "shdb.cardsTableState",
  INBOX_PANEL_OPEN: "shdb.inboxPanelOpen",
  DASHBOARD_LIST_SORTING: "shdb.dashboardListSorting",
  DASHBOARD_LIST_GROUPING: "shdb.dashboardListGrouping",
  DASHBOARD_LIST_COLUMNS: "shdb.dashboardListColumns",
  SHOW_ALL_REPAIR_ORDERS: "shdb.showAllRepairOrders",
  CUSTOMER_UPDATES_PANEL_SHOW_ALL: "shdb.customerUpdatesPanelShowAll",
  DISPATCH_VIEW_MODE: "shdb.dispatchViewMode",
  DISPATCH_VIEW_EMPLOYEE_MODE: "shdb.dispatchViewEmployeeMode",
  CONTAINER_METRICS_LAYOUT_ID: "shdb.containerMetricsLayoutId",
  SEEN_AUTOMATION_TOAST_KEYS: "shdb.seenAutomationToastKeys",
  TASK_LIST_FILTERS: "shdb.taskListFilters",
  DISPATCH_TECHNICIAN_HOURS_COLUMNS: "shdb.dispatchTechnicianHoursColumns",
  DISPATCH_EMPLOYEE_JOBS_COLUMNS: "shdb.dispatchEmployeeJobsColumns",
} as const;

export type LocalStorageBaseKey = keyof typeof LOCAL_STORAGE_BASE_KEYS;
